import { render, staticRenderFns } from "./BranchDetailsEditor.vue?vue&type=template&id=51ad2785&scoped=true"
import script from "./BranchDetailsEditor.vue?vue&type=script&lang=ts"
export * from "./BranchDetailsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad2785",
  null
  
)

export default component.exports